const HelpText = ({helpText}) => {
    if(helpText){
        return <div class="small text-warning w-100">{ helpText }</div> 
    }
    return 
}

export default HelpText